import { MenuItemIconSize } from '@/Constants/TailwindClassNames';
export const iconClass = `text-neutral mr-2 ${MenuItemIconSize}`;
